export default __webpack_public_path__ + "static/media/nikujaga.81d51431.gif";